"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Virbela = void 0;

var Virbela =
/** @class */
function () {
  function Virbela() {}

  Virbela.prototype.VirbelaRoleType = function () {
    return [{
      slug: 'member',
      name: 'Member',
      description: null,
      isMember: true,
      isAdmin: false,
      isSuspended: false,
      isModerator: false,
      isLeader: false
    }, {
      slug: 'moderator',
      name: 'Moderator',
      description: null,
      isMember: false,
      isAdmin: false,
      isSuspended: false,
      isModerator: true,
      isLeader: false
    }, {
      slug: 'admin',
      name: 'Admin',
      description: null,
      isMember: false,
      isAdmin: true,
      isSuspended: false,
      isModerator: false,
      isLeader: false
    }, {
      slug: 'suspended',
      name: 'Suspended',
      description: null,
      isMember: false,
      isAdmin: false,
      isSuspended: true,
      isModerator: false,
      isLeader: false
    }, {
      slug: 'leader',
      name: 'Leader',
      description: null,
      isMember: false,
      isAdmin: false,
      isSuspended: false,
      isModerator: false,
      isLeader: true
    }];
  };

  return Virbela;
}();

exports.Virbela = Virbela;